export const DEFAULT_HOMEPAGE = {
  header: {
    kmsBadge: "KMS:  2026-27 READY",
    loginButton: "Login",
    navHow: "How it works",
    navFeatures: "Features",
    navContact: "Contact",
  },
  hero: {
    eyebrow: "INDIA’S #1 RICE MANDI QR PLATFORM",
    titleBefore: "Generate & Print",
    titleHighlight1: "Unique QR Tags",
    titleMid: "for Government Rice",
    titleHighlight2: "Gunny Bags",
    titleAfter: "in Seconds",
    subtitle:
      "Built specifically for Indian Rice Millers, Grain Procurement Agencies & Mandi Arhtiyas. 2D visual designer, zero-margin QR Tag roll printing, and 100% scannable unique QR tags for FCI, PUNSUP, PUNGRAIN, MARKFED, PSWC, HAFED & DFSC.",
    loginButton: "Login",
    check1: "Zero Software Installation",
    check2: "QR Tag Roll Ready",
    previewLabel: "Real QR Tag Preview",
    previewBadge: "QR TAG",
    previewCaption: "Scannable with any mobile phone",
  },
  agencies: {
    heading: "APPROVED & COMPATIBLE WITH GOVERNMENT PROCUREMENT AGENCIES ACROSS INDIA",
    items: [
      { name: "PUNSUP", sub: "Punjab Civil Supplies" },
      { name: "FCI", sub: "Food Corporation of India" },
      { name: "MARKFED", sub: "Punjab State Coop" },
      { name: "PUNGRAIN", sub: "Grain Procurement Corp" },
      { name: "PSWC", sub: "State Warehousing Corp" },
      { name: "HAFED", sub: "Haryana Supply Fed" },
      { name: "DFSC", sub: "District Food & Supplies" },
    ],
  },
  howItWorks: {
    eyebrow: "FROM LOGIN TO SCAN",
    title: "How RiceQRCodes works",
    steps: [
      {
        num: "01",
        title: "Login",
        text: "Sign in with your miller credentials. Previous QR designs and last printed serials are already saved.",
      },
      {
        num: "02",
        title: "Design the tag",
        text: "Drag fields on the QR Tag canvas. Hide print text while keeping 100% of the data inside the unique QR tag.",
      },
      {
        num: "03",
        title: "Print serial range",
        text: "Enter from–to serial numbers. Each gunny bag gets its own scannable QR with CNS, commodity, and miller data.",
      },
      {
        num: "04",
        title: "Scan anywhere",
        text: "FCI, PUNSUP, DFSC and mandi staff scan with any phone. No extra app is required.",
      },
    ],
  },
  features: {
    eyebrow: "BUILT FOR KMS 2026-27",
    title: "Everything you need on one QR tag",
    items: [
      {
        title: "Freeform 2D designer",
        text: "Place QR, logos, and text anywhere on a millimetre canvas. What you see is what prints.",
      },
      {
        title: "Unique QR per bag",
        text: "Every gunny bag gets a unique serial and QR payload for KMS 2026-27 procurement.",
      },
      {
        title: "Hide text, keep data",
        text: "Turn off printed lines on the label. The QR still encodes 100% of the government fields.",
      },
      {
        title: "Saved miller templates",
        text: "Reuse the last design and continue serials from the last printed number automatically.",
      },
      {
        title: "QR Tag rolls",
        text: "Zero-margin continuous QR Tag rolls. Ready for standard gunny bag tag printers.",
      },
      {
        title: "Agency compliant",
        text: "Built for FCI, PUNSUP, PUNGRAIN, MARKFED, PSWC, HAFED and DFSC scanning.",
      },
    ],
  },
  printers: {
    eyebrow: "100% PLUG & PLAY",
    title: "Compatible with Your Existing QR Tag Roll Printers",
    text: "No proprietary printer drivers required. Works directly through standard Windows and Chrome QR Tag printing drivers. Unique QR tags print on rolls.",
    itemNote: "Continuous QR Tag roll",
    items: [
      { name: "TSC", models: "TE244, DA210, TTP-244 Pro" },
      { name: "Zebra", models: "ZD220, ZD230, GT800" },
      { name: "TVS", models: "LP 46, RP 3200" },
      { name: "Citizen", models: "CL-E300, CL-S621" },
      { name: "Rongta", models: "RP4xx Series" },
    ],
  },
  audience: {
    eyebrow: "WHO IT IS FOR",
    title: "One platform for millers, agencies & mandis",
    items: [
      {
        title: "Rice Millers",
        text: "Print unique QR tags for CMR and paddy gunny bags in seconds during peak KMS.",
      },
      {
        title: "Procurement agencies",
        text: "Scan miller, commodity, crop year, CNS and serial data on any smartphone.",
      },
      {
        title: "Mandi arhtiyas",
        text: "Issue compliant tags at the mandi without installing extra software.",
      },
    ],
  },
  faqs: {
    title: "Frequently Asked Questions",
    items: [
      {
        q: "Is RiceQRCodes.com compliant with FCI and Punjab/Haryana Mandi standards?",
        a: "Yes. Unique QR tags for government rice gunny bags encode 100% of required data for FCI, PUNSUP, PUNGRAIN, MARKFED, PSWC, HAFED and DFSC.",
      },
      {
        q: "Can I hide text fields on the printed label while keeping them in the QR code?",
        a: "Yes. You can hide any printed text on the gunny bag tag while the unique QR tag still carries the full data for scanners.",
      },
      {
        q: "Which roll label sizes are supported?",
        a: "QR Tags rolls are supported, with zero-margin printing on standard Windows.",
      },
      {
        q: "Does it work with standard QR Tag printers like Zebra and TSC?",
        a: "Yes. It is 100% plug & play with TSC, Zebra, TVS, Citizen and Rongta roll printers. No proprietary drivers are required.",
      },
      {
        q: "Can more than one person use the same miller login?",
        a: "No. Each customer account allows one active login. Signing in from another device logs out the previous session. Idle sessions close after 10 minutes.",
      },
    ],
  },
  contact: {
    eyebrow: "TALK TO US",
    title: "Ready for KMS 2026-27 unique QR tags?",
    text: "Get miller login, QR Tag printing, and agency-ready unique QR tags set up for your rice mill.",
    loginButton: "Login to start printing",
    dealerLine1: "North Zone Dealer",
    dealerLine2: "Prabhu Labels",
    dealerLine3: "Ludhiana",
    phone1: "9417771111",
    phone2: "8711088000",
    whatsapp1: "9417771111",
    whatsapp2: "8711088000",
    email: "info@riceqrcodes.com",
  },
  footer: {
    copyright: "RiceQRCodes.com © 2026 • Dedicated Rice & Grain Labelling Software",
  },
};

export const mergeHomepage = (base, extra) => {
  if (!extra || typeof extra !== "object") {
    return JSON.parse(JSON.stringify(base));
  }
  const out = JSON.parse(JSON.stringify(base));
  Object.keys(extra).forEach((key) => {
    const value = extra[key];
    if (Array.isArray(value)) {
      out[key] = value;
    } else if (value && typeof value === "object") {
      out[key] = mergeHomepage(out[key] || {}, value);
    } else if (value !== undefined) {
      out[key] = value;
    }
  });
  return out;
};

const listedNumbers = (...values) =>
  values.map((value) => String(value || "").trim()).filter(Boolean);

export const phoneNumbers = (contact = {}) =>
  listedNumbers(contact.phone1, contact.phone2);

export const whatsappNumbers = (contact = {}) => {
  const numbers = listedNumbers(contact.whatsapp1, contact.whatsapp2);
  return numbers.length ? numbers : phoneNumbers(contact);
};

const indiaDigits = (value) => {
  let digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 10) digits = `91${digits}`;
  return digits;
};

export const formatIndiaNumber = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 10) return `+91 ${digits}`;
  if (digits.startsWith("91") && digits.length === 12) {
    return `+91 ${digits.slice(2)}`;
  }
  return String(value || "").trim();
};

export const telHref = (value) => {
  const digits = indiaDigits(value);
  return digits ? `tel:+${digits}` : "";
};

export const whatsappHref = (value) => {
  const digits = indiaDigits(value);
  return digits
    ? `https://api.whatsapp.com/send?phone=${digits}&text=Hello`
    : "";
};
